import React from "react";
import { Box, Alert, Typography } from "@curves/ui-base";
import { TimeLine } from "@curves/ui-shared";
import { useSmartFitnessContext } from "@icoach/smartFitnessBand/components/SmartFitnessContext";
import { isEmpty } from "@util/utils";
import { ActivityRecordCard } from "@shared/components";
import { adaptDeviceOrderChange } from "@icoach/memberDetail/components/memberChangeRecord";

const SmartFitnessBandContractDetailOrderHistoryPanel = props => {
	const { contractApplySourceData } = useSmartFitnessContext();
	const { records = [] } = contractApplySourceData;

	if (isEmpty(records)) {
		return (
			<Alert className={"mb-4"} color="info" severity="info" variant="filled">
				無歷史資料
			</Alert>
		);
	}
	return (
		<Box>
			<TimeLine as="ul" className="membership-record">
				{records.map((item, index) => {
					const itemData = adaptDeviceOrderChange(item);
					return (
						<TimeLine.Item key={index} as="li">
							<Box className="timeline-record-item">
								<Box className="timeline-record-item__meta">
									{(itemData.timelineMetainfo || []).map((meta, metaIndex) => (
										<Box key={metaIndex} className="timeline-record-item__meta-row">
											<span className="label">{meta.label}</span>
											<span className="text">{meta.text}</span>
										</Box>
									))}
								</Box>
								<Box className="timeline-record-item__card">
									<ActivityRecordCard status={itemData.type}>
										{itemData.pdfUrl && <ActivityRecordCard.PdfAttachment pdfUrl={itemData.pdfUrl} />}
										<ActivityRecordCard.Content style={isEmpty(itemData.descList) ? { display: "flex", alignItems: "center" } : undefined}>
											<Box className="activity-record-card__main">
												<Typography variant="h6" className="title">
													{itemData.title}
												</Typography>
												{!isEmpty(itemData.descList) &&
													itemData.descList.map((desc, descIndex) => (
														<Typography key={descIndex} variant="body2" className="mb-1">
															{desc.label ? `${desc.label}：${desc.text}` : desc.text}
														</Typography>
													))}
											</Box>
										</ActivityRecordCard.Content>
									</ActivityRecordCard>
								</Box>
							</Box>
						</TimeLine.Item>
					);
				})}
			</TimeLine>
		</Box>
	);
};

export default SmartFitnessBandContractDetailOrderHistoryPanel;
